<template>
  <div class="versionNew">
    <div class="lastTitle">
       <span v-if="!isShowTemplateDetail">新版模板消息(通知)设置</span>
       <span v-else>
         <span><span style="color:#01AAED;margin-right:5px">{{templateTypeName}}</span>模板设置</span><span><i v-if="isShowTemplateDetail" style="cursor:pointer" class="el-icon-close" @click="isShowTemplateDetail=false"></i></span>
       </span>
    </div>
    <div class="versionContent">
      <div v-show="!isShowTemplateDetail" class="templateType" :key="index" v-for="(item,index) in templateTypeList" @click="templateTypeClick(item)">{{item.label}}</div>
      <div v-if="isShowTemplateDetail" class="templateDetail">
        <CardOfNew :cardOfNewOptions='cardOfNewOptions'></CardOfNew>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/config/api'
import CardOfNew from './CardOfNew'
export default {
  data(){
      return{
          templateTypeName:'会员卡充值',
          isShowTemplateDetail:false,
          cardOfNewOptions:[//不同动作类型的配置导致不同内容的卡片
            {
                templateTitle:'',
                tipContents:[
                    {label:'激活卡号',value:'123456789'},
                    {label:'激活时间',value:'2021年4月19日 15:56'}
                ],
                templateRemark:'',
                templateSerialNumber:'',
                templateId:'',
                templateSwitch:false,
                templateTitleColor:'',
                tipValueColor:'',
                templateRemarkColor:'',	  
                cardInfo:{}//服务端原始数据结构
            }
          ],
          templateTypeList:[
            {label:'会员卡激活',id:'1'},
            {label:'会员卡充值',id:'2'},
            {label:'会员消费',id:'3'},
            {label:'优惠券发放',id:'4'},
            {label:'退款通知',id:'5'}
          ]
      }
  },
  components:{
    // CardOfNew:()=>import('./CardOfNew')
    CardOfNew
  },
  methods:{
    seee(){
      console.log('会员卡充值父对象变了吗',this.cardOfNewOptions[1])
    },
    //修正中间显示的tipContent内容
    fixTipContents(tipContents){
      let my_tipContents=[]
      for(let i=0;i<tipContents.length;i++){
        if(tipContents[i]){
          let objectAdapter={
            label:tipContents[i].split('：')[0],
            value:tipContents[i].split('：')[1]
          }
          my_tipContents.push(objectAdapter);
        }
      }
      return my_tipContents;
    },
    templateTypeClick(item){
      this.templateTypeName=item.label;

      const loading=this.$loading();
      let url=api.system.newTemplateList;
      let data={};
      switch (item.id) {
        case '1'://会员卡激活
          data={
            type:1
          }
          this.cardOfNewOptions=[];
          this.getActionData(url,data,loading);
          break;
        case '2'://会员卡充值
          data={
            type:2
          }
          this.cardOfNewOptions=[];
          this.getActionData(url,data,loading);
          break;
        case '3'://会员消费
          data={
            type:3
          }
          this.cardOfNewOptions=[];
          this.getActionData(url,data,loading);    
          break;
        case '4'://优惠券发放
          data={
            type:4
          }
          this.cardOfNewOptions=[];
          this.getActionData(url,data,loading);   
          break;
        case '5'://退款通知
          data={
            type:5
          }
          this.cardOfNewOptions=[];
          this.getActionData(url,data,loading);     
          break;
      
        default:
          break;
      }
    },
    //获取不同类型动作数据,刷新cardOfNewOptions数据
    getActionData(url,data={type:1},loading){
      this.$axios.fetchPost(url,data).then((res)=>{
        loading.close();
        this.isShowTemplateDetail=true;
        if(res.code===200){
          for(let i=0;i<res.data[0].length;i++){
              let tipContents=[
                //会员卡激活
                res.data[0][i].memberNumber,
                res.data[0][i].memberRank,
                res.data[0][i].memberName,
                res.data[0][i].memberPhone,
                res.data[0][i].memberAddtime,
                res.data[0][i].memberBalance,
                //会员卡充值
                res.data[0][i].rechargeAddtime,
                res.data[0][i].rechargeMode,
                res.data[0][i].rechargeMoney,
                res.data[0][i].rechargeNumber,
                res.data[0][i].rechargeStatus,
                res.data[0][i].memberIntegral,
                //会员卡消费
                res.data[0][i].consumeAddtime,
                res.data[0][i].consumeMoney,
                res.data[0][i].consumeStore,
                res.data[0][i].orderNumber,
                res.data[0][i].consumeMode,
                //优惠券发放
                res.data[0][i].discountsName,
                res.data[0][i].expirationDate,
                res.data[0][i].provideDate,
                //退款
                res.data[0][i].refundMoney,
                res.data[0][i].refundTime,
                res.data[0][i].refundType,               
              ]
              let objectAdapter={
                templateTitle:res.data[0][i].templateTitle,
                tipContents:this.fixTipContents(tipContents),
                templateRemark:res.data[0][i].templateRemark,
                templateSerialNumber:res.data[0][i].templateNumber,
                templateId:res.data[0][i].templateId,
                templateSwitch:res.data[0][i].use?true:false,
                templateTitleColor:res.data[0][i].titlecolor,
                tipValueColor:res.data[0][i].bodycolor,
                templateRemarkColor:res.data[0][i].remarkcolor,
                type:data.type,
                cardInfo:res.data[0][i]
              }
              this.cardOfNewOptions.push(objectAdapter);
          }
          console.log('我的cardOfNewOptions',this.cardOfNewOptions)
        }else{
          this.$message.error('模板拉取失败！');
        }
      }) 
    }
  }
}
</script>

<style scoped>
.lastTitle{
  height: 42px;
  padding: 0px 15px;
  border-bottom: 1px solid #f6f6f6;
  line-height: 42px;
}
.lastTitle span:nth-of-type(1){
  display: flex;
  justify-content: space-between;
}
.lastTitle .el-icon-close{
  font-weight: bold;
  font-size: 26px;
}

.versionContent{
    margin-top:15px;
    padding:0px 15px;
    display: flex;
    flex-flow: row wrap;  
}
.versionContent .templateType{
    width: 200px;
    height: 80px;
    margin-right: 30px;
    background-color: #f1f1f1;
    cursor: pointer;

    color:#01AAED;
    text-align: center;
    font-size: 15px;
    line-height: 80px;
}
.versionContent .templateDetail{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/system/wechat/VersionNew.vue